"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _button = _interopRequireDefault(require("@ux/button"));
var _x = _interopRequireDefault(require("@ux/icon/x"));
var _text = _interopRequireDefault(require("@ux/text"));
var _shapes = _interopRequireDefault(require("./shapes"));
var _listEmpty = _interopRequireDefault(require("./list-empty"));
var _listItem = _interopRequireDefault(require("./list-item"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */

/**
 * Renders Notification list-item information or list-empty error.
 *
 * @class NotificationList
 * @public
 *
 * @returns {React.ReactElement} Notification component
 */

class NotificationList extends _react.Component {
  render() {
    const {
      notifications,
      sso,
      messages,
      closeList,
      error
    } = this.props;
    function stopPropagation(e) {
      e.stopPropagation();
    }
    const classes = 'notifications-list';
    return (
      /*#__PURE__*/
      // jsx-a11y/no-static-element-interactions
      _react.default.createElement("div", {
        className: classes,
        onClick: stopPropagation
      }, /*#__PURE__*/_react.default.createElement(_button.default, {
        "aria-label": messages.closeText,
        className: "notifications-close",
        design: "stateless",
        icon: /*#__PURE__*/_react.default.createElement(_x.default, null),
        onClick: closeList
      }), /*#__PURE__*/_react.default.createElement(_text.default.div, {
        as: "title",
        className: "notifications-title",
        text: messages.headerText
      }), /*#__PURE__*/_react.default.createElement("ul", {
        className: "notifications-list-items",
        id: "notifications-list-items"
      }, notifications && notifications.length > 0 ? notifications.map((n, c) => {
        return /*#__PURE__*/_react.default.createElement(_listItem.default, {
          key: c,
          index: c,
          notification: n
        });
      }) : /*#__PURE__*/_react.default.createElement(_listEmpty.default, {
        error: error,
        messages: messages,
        sso: sso
      })))
    );
  }
}

/**
 * Property definitions.
 *
 * @type {Object}
 * @public
 *
 */

NotificationList.propTypes = {
  /** Used for sign on link when there is 401 error */
  sso: _shapes.default.sso.isRequired,
  /** Notification strings with translations */
  messages: _shapes.default.messages.isRequired,
  /**  User notifications */
  notifications: _propTypes.default.arrayOf(_shapes.default.notification),
  /** On click sets isOpen state to false */
  closeList: _propTypes.default.func,
  /** Provides error code */
  error: _propTypes.default.object
};
var _default = NotificationList;
exports.default = _default;